import { IDocument } from '../../entities/Document/Document';
import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';

export class DocumentApi extends BaseApi {
  private static baseApiUrl: string = `${BaseApi.apiUrl}`;
  public static apiUrls = {
    getDocuments: `${DocumentApi.baseApiUrl}/Patients/:id/Documents`,
    getDocument: `${DocumentApi.baseApiUrl}/Documents/:id`,
    deleteDocument: '/Documents/:id',
    postDocument: '/Documents',
    putDocument: `${DocumentApi.baseApiUrl}/Documents/:id`,
    getUploadUrl: '/Patients/:patientId/Documents/:documentId/UploadURL/:filename',
    getDownloadUrl: '/Patients/:patientId/Documents/:documentId/DownloadURL/:filename',
  };

  public static async getDocuments(patientId: string): Promise<IDocument[]> {
    return this.sendApiRequest<IDocument[]>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.getDocuments,
      id: patientId,
    });
  }

  public static async getDocument(documentId: string): Promise<IDocument> {
    return this.sendApiRequest<IDocument>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.getDocument.replace(':id', documentId),
    });
  }

  public static async deleteDocument(documentId: string): Promise<void> {
    return this.sendApiRequest<void>({
      method: HttpMethodEnum.DELETE,
      path: this.apiUrls.deleteDocument.replace(':id', documentId),
      id: documentId,
    });
  }
  
  public static async postDocument(payload: IDocument): Promise<number> {
    return this.sendApiRequest<number>({
      method: HttpMethodEnum.POST,
      path: this.apiUrls.postDocument,
      data: payload,
    });
  }

  public static async putDocument(documentId: number, document: IDocument): Promise<void> {
    return this.sendApiRequest<void>({
      method: HttpMethodEnum.PUT,
      path: this.apiUrls.putDocument.replace(':id', documentId.toString()),
      data: document,
    });
  }

  public static async getUploadUrl(patientId: string, documentId: string, filename: string): Promise<S3UploadPolicy> {
    return this.sendApiRequest<S3UploadPolicy>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.getUploadUrl.replace(':patientId', patientId).replace(':documentId', documentId).replace(':filename', filename),
    });
  }

  public static async getDownloadUrl(patientId: string, documentId: string, filename: string): Promise<string> {
    return this.sendApiRequest<string>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.getDownloadUrl.replace(':patientId', patientId).replace(':documentId', documentId).replace(':filename', filename),
    });
  }
} 

export type S3UploadPolicy = {
  key: string;
  'Content-Type': string;
  'x-amz-algorithm': string;
  'x-amz-credential': string;
  'x-amz-date': string;
  'x-amz-signature': string;
  policy: string;
  url: string;
};